import { Link } from "react-router-dom";
import { AddCircleIcon } from "../../icons";

// The "create a record" entry point for the admin list pages — rendered in the
// page header via <AdminPage actions={...} />.
const AdminCreateButton = ({ to, label }) => (
  <Link
    to={to}
    className="tw:flex tw:h-[45px] tw:items-center tw:gap-2 tw:rounded-[5px] tw:border-0 tw:bg-[#282828] tw:px-[17px] tw:text-[15px] tw:leading-[22px] tw:!text-white tw:font-hanken-grotesk tw:!no-underline"
  >
    <AddCircleIcon />
    {label}
  </Link>
);

export default AdminCreateButton;
